import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=494d0ea4&scoped=true"
import script from "./pagenation.vue?vue&type=script&lang=ts"
export * from "./pagenation.vue?vue&type=script&lang=ts"
import style0 from "./pagenation.vue?vue&type=style&index=0&id=494d0ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d0ea4",
  null
  
)

export default component.exports